document.addEventListener("DOMContentLoaded", () => {
    const popup = document.getElementById("similar-products-popup"),
        container = document.getElementById("similar-products-container"),
        openPopup = productId => {
            const template = document.getElementById(`similar-products-template-${productId}`);
            if (!template || !container || !popup) return;
            const fragment = template.content ? template.content.cloneNode(!0) : null;
            fragment ? container.replaceChildren(fragment) : container.innerHTML = template.innerHTML, requestAnimationFrame(() => {
                popup.classList.add("active"), document.body.classList.add("overflow-hidden")
            })
        },
        closePopup = () => {
            requestAnimationFrame(() => {
                popup.classList.remove("active"), document.body.classList.remove("overflow-hidden")
            })
        };
    document.addEventListener("click", e => {
        const trigger = e.target.closest(".similar_products_trigger");
        trigger && trigger.dataset.productId && openPopup(trigger.dataset.productId), (e.target.classList.contains("similar-popup") || e.target.closest(".popup-close")) && closePopup()
    }, {
        passive: !0
    })
});
//# sourceMappingURL=/cdn/shop/t/114/assets/similar-products.js.map?v=183444082406540964041769662972